module.exports = { "default": require("core-js/library/fn/object/entries"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** /home/rengasturku/nettivanne/~/babel-runtime/core-js/object/entries.js
 ** module id = 408
 ** module chunks = 0 1 2 10 11 17 19 20 26 33
 **/